var _rect, _g, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _circle3, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclerLeftImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1024,
    viewBox: "0 0 720 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "#0061DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 640.5,
    y1: 2.18557e-8,
    x2: 640.5,
    y2: 1024,
    stroke: "#719DF4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.5,
    y1: 2.18557e-8,
    x2: 480.5,
    y2: 1024,
    stroke: "#719DF4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: 2.18557e-8,
    x2: 160.5,
    y2: 1024,
    stroke: "#719DF4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.5,
    y1: 2.18557e-8,
    x2: 320.5,
    y2: 1024,
    stroke: "#719DF4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18557e-8,
    x2: 0.499955,
    y2: 1024,
    stroke: "#719DF4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 341,
    r: 49,
    stroke: "#80BFFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 683,
    r: 49,
    stroke: "#42F0D3",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 682.167,
    x2: 720,
    y2: 682.167,
    stroke: "#719DF4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 170.167,
    x2: 720,
    y2: 170.167,
    stroke: "#719DF4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 852.833,
    x2: 720,
    y2: 852.833,
    stroke: "#719DF4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 340.833,
    x2: 720,
    y2: 340.833,
    stroke: "#719DF4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.3,
    y1: 511.5,
    x2: 720,
    y2: 511.5,
    stroke: "#719DF4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 512,
    r: 50,
    fill: "#42F0D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 0H210V215C210 242.614 187.614 265 160 265C132.386 265 110 242.614 110 215V0Z",
    fill: "url(#paint0_linear_835_10512)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270 462C297.614 462 320 484.386 320 512C320 539.614 297.614 562 270 562L-4.37114e-06 562L0 462L270 462Z",
    fill: "url(#paint1_linear_835_10512)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 903C110 875.386 132.386 853 160 853C187.614 853 210 875.386 210 903L210 1024H110L110 903Z",
    fill: "url(#paint2_linear_835_10512)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M530 121C530 148.614 507.614 171 480 171C452.386 171 430 148.614 430 121L430 -8.74228e-06L530 0L530 121Z",
    fill: "url(#paint3_linear_835_10512)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M430 810C430 782.386 452.386 760 480 760C507.614 760 530 782.386 530 810V1024H430V810Z",
    fill: "url(#paint4_linear_835_10512)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_10512",
    x1: 160,
    y1: 258.826,
    x2: 160,
    y2: 0.00000114803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42F0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42F0D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_10512",
    x1: 320,
    y1: 512,
    x2: -0.00000218557,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#719DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#719DF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_10512",
    x1: 160,
    y1: 853,
    x2: 160,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#719DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#719DF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_835_10512",
    x1: 480,
    y1: 171,
    x2: 480,
    y2: -0.00000437114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#719DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#719DF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_835_10512",
    x1: 480,
    y1: 760,
    x2: 480,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D40A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D40A5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclerLeftImage);
export default __webpack_public_path__ + "static/media/CirclerLeftImage.5969e5b0bf5269d17c49be24ddc79348.svg";
export { ForwardRef as ReactComponent };